module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_3.f0018a4b.png";